<mat-toolbar class="topbar">
    <!-- Mobile Menu -->
    <button
            type="button"
            mat-icon-button
            class="mobile-navigation-toggle d-flex d-md-none justify-content-center"
            aria-controls="mobile-navigation"
            [attr.aria-expanded]="toggleChecked"
            [attr.aria-label]="toggleChecked ? 'Close navigation' : 'Open navigation'"
            (click)="toggleMobileNav.emit()">
        <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>

    @if (localDevelopmentLayout; as localLayout) {
        <span class="topbar-title local-development-title">{{ localLayout.title }}</span>
        <span class="topbar-spacer"></span>
        <span class="local-development-label">Local development</span>
    } @else {
    @if (!environment.production) {
        <h3 class="topbar-environment-title">
            {{ environment.environment }} Environment
        </h3>
    }

    <!-- Display name of client -->
    <span class="topbar-title topbar-title--desktop">{{ clientService.client?.name }}</span>

    <span class="topbar-spacer"></span>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <h3 class="topbar-title topbar-title--mobile">{{ clientService.client?.name }}</h3>

    <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
        <img [src]="getLogo()" class="rounded-circle object-cover" width="35"/>
    </button>
    <mat-menu #profilemenu="matMenu" class="cardWithShadow">
        <button mat-menu-item (click)="openClientSettings()" [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler name="user-circle" class="icon-18 d-flex"></i-tabler>
            </mat-icon>
            My Account
        </button>
        <button mat-menu-item (click)="openApiKeys()" [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler name="key" class="icon-18 d-flex"></i-tabler>
            </mat-icon>
            API Keys
        </button>
        <button mat-menu-item (click)="openConnections()" [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler class="icon-18 d-flex" name="arrows-exchange"></i-tabler>
            </mat-icon>
            Connections
        </button>
        <button mat-menu-item (click)="openDomains()" [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler class="icon-18 d-flex" name="world"></i-tabler>
            </mat-icon>
            Domains
        </button>
        <button mat-menu-item (click)="openUsers()" [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler class="icon-18 d-flex" name="users"></i-tabler>
            </mat-icon>
            Users
        </button>
        @if (isInternalAdmin) {
            <button (click)="openProviders()" [disabled]="clientLoading$ | async" mat-menu-item>
                <mat-icon class="d-flex align-items-center">
                    <i-tabler class="icon-18 d-flex" name="settings-2"></i-tabler>
                </mat-icon>
                Providers
            </button>
        }
        <!-- Client selector button - always visible -->
        <button (click)="showClientSelector()" mat-menu-item [disabled]="clientLoading$ | async">
            <mat-icon class="d-flex align-items-center">
                <i-tabler class="icon-18 d-flex" name="users-plus"></i-tabler>
            </mat-icon>
            Select Client
        </button>

        <div class="p-x-12 m-t-12">
            <a (click)="logout()" mat-stroked-button color="primary" class="w-100">
                <mat-icon class="d-flex align-items-center">
                    <i-tabler name="logout" class="icon-18 d-flex"></i-tabler>
                </mat-icon>
                Logout
            </a>
        </div>
    </mat-menu>
    }

</mat-toolbar>
@if (localDevelopmentLayout) {
    <div class="local-development-banner">Your integration runs against the local backend on this computer.</div>
} @else {
    <app-client-preparation-status></app-client-preparation-status>
}
